import { IStatement, IShootoutStatement } from "./interfaces";
import { config } from "./constants";

export function slugify(string: string): string {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźżΑαΒβΓγΔδΕεΖζΗηΘθΙιΚκΛλΜμΝνΞξΟοΠπΡρΣσςΤτΥυΦφΧχΨψΩω·/_,:;";
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzzaabbccddeezziittiikkllmmnnxxoopprrsssttuuffccppoo------";

  const p = new RegExp(a.split("").join("|"), "g");

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/&/g, "-and-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export function statementTitleToString(
  title: IStatement["title"] | IShootoutStatement["title"],
): string {
  if (typeof title === "string") return title;

  let stringTitle = "";

  title.forEach((titlePart) => {
    if (stringTitle) stringTitle += " ";

    if (typeof titlePart === "string") {
      stringTitle += titlePart;
    } else {
      stringTitle += titlePart.text;
    }
  });

  return stringTitle;
}

export function trackGAEvent(event: string) {
  // extra check to ensure _paq is defined
  if (typeof _paq !== "undefined") {
    if (
      process.env.VUE_APP_MATOMO_ID &&
      process.env.VUE_APP_MATOMO_URL &&
      _paq
    ) {
      let category = "vmEvent";
      if (config.settings.analytics.title) {
        category = `${config.settings.analytics.title}`;
      }
      if (config.settings.analytics.matomoEventCategory) {
        category = `${config.settings.analytics.matomoEventCategory}`;
      }
      _paq.push(["trackEvent", category, event, location.href]);
    }
  }

  // extra check to ensure ga is enabled
  if (typeof gtag !== "undefined") {
    if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID && gtag) {
      let category = "vmEvent";
      if (config.settings.analytics.title) {
        category = `${config.settings.analytics.title}`;
      }
      if (config.settings.analytics.gaEventCategory) {
        category = `${config.settings.analytics.gaEventCategory}`;
      }

      gtag("event", event, {
        event_category: category,
        event_label: location.href,
      });
    }
  }
}

export function isEmbedded(): boolean {
  return window.location !== window.parent.location;
}
